export default __webpack_public_path__ + "static/media/createPostcolor.93fcc111.png";